import { getPathsCoords } from 'src/utils';
import type { IApiSection, ISection } from 'src/interfaces';

export const mapApiToSection = ({ cemetery, geometry, id, no }: IApiSection): ISection => ({
  cemetery,
  coords: getPathsCoords(geometry),
  id,
  number: no,
});
